export default __webpack_public_path__ + "static/carboot-3fe062977bd4ed9dc47bd1eef4ad60ef.jpg";